import React from 'react';
import {
    Box,
    Card,
    Grid,
    Divider,
    Typography, withStyles, Hidden
} from '@material-ui/core';
import QuotePageEquipmentSearch from "./quotePageEquipamentSearch";
import QuotePageFinancialSummary from "./quotePageFinancialSummary";
import QuotePageAttachmentsSection from "./quotePageAttachmentsSection";
import QuotePageEquipmentList from "./quotePageEquipamentList";
import QuotePageModalItens from "./quotePageModalItens";
import QuotePageOverlayAdd from "./quotePageOverlayAdd";
import { CustomTextField } from "../common/customTextField";
import { CustomSelect } from "../common/customSelect";
import CustomButton from "../common/customButton";

const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#FFFFFF',
        minHeight: '100vh',
    },
    card: {
        marginBottom: '1rem',
        padding: '1rem',
        border: '1px solid #DEE2E6',
        borderRadius: '0.375rem',
        boxShadow: 'none',
    },
    addEquipSection: {
        marginBottom: '1rem',
    },
    addEquipTitle: {
        marginBottom: '0.5rem',
        fontWeight: '700',
        fontSize: '1rem',
        color: '#212529',
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: '1.5rem',
    }
});

const QuotePageForm = ({
    // Dados básicos
    cliente,
    tecnico,
    status,
    onStatusChange,

    // Estado da busca
    buscaEquipamento,
    sugestoesEquipamento,
    onSearchChange,
    onSearchFocus,
    onSelectEquipment,

    // Equipamentos do orçamento
    equipamentosOrcamento,
    onAddItem,
    onRemoveEquipment,
    onRemoveItem,

    // Dados financeiros
    totalItens,
    desconto,
    totalFinal,
    onDescontoChange,

    // Modal de itens
    modalItensAberto,
    buscaItemModal,
    onBuscaItemModalChange,
    itensFiltrados,
    onFecharModalItens,
    onAbrirOverlay,

    // Overlay
    overlayAberto,
    overlayItem,
    overlayQtd,
    overlayObs,
    overlayPreco,
    onOverlayQtdChange,
    onOverlayObsChange,
    onOverlayPrecoChange,
    onFecharOverlay,
    onConfirmarOverlay,

    // Anexos
    tabAnexosAtiva,
    anexos,
    notasFiscais,
    onTabAnexosChange,
    onUploadAnexo,
    onUploadNota,
    onExcluirAnexo,
    onExcluirNota,

    // Ações
    onSaveQuote,
    userRole = 'tecnico',
    currentLanguage,
    classes,
}) => {

    const formatCurrency = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor);
    };

    return (
        <Box>
            <Card className={classes.card}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <CustomTextField
                            fullWidth
                            label={currentLanguage.bepiService.shared.shared_resp_client_name}
                            value={cliente}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CustomTextField
                            fullWidth
                            label={currentLanguage.bepiService.workshop.workshop_quote_form_tech_label}
                            value={tecnico}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <CustomSelect
                            value={status}
                            onChange={onStatusChange}
                            label={currentLanguage.bepiService.shared.shared_quotation_table_status}
                            items={[
                                { value: "aguardando orçamento", label: currentLanguage.bepiService.workshop.workshop_status_waiting_quote },
                                { value: "pendente de aprovação", label: currentLanguage.bepiService.workshop.workshop_status_pending_approval },
                                { value: "aprovado para manutencao", label: currentLanguage.bepiService.workshop.workshop_status_approved },
                                { value: "aguardando inspeção e laudo", label: currentLanguage.bepiService.workshop.workshop_status_waiting_inspection },
                                { value: "aguardando faturamento", label: currentLanguage.bepiService.workshop.workshop_status_waiting_invoice },
                                { value: "pronto para retirada", label: currentLanguage.bepiService.workshop.workshop_status_ready },
                                { value: "finalizado", label: currentLanguage.bepiService.workshop.workshop_status_finished },
                                { value: "recusado", label: currentLanguage.bepiService.workshop.workshop_status_refused },
                            ]}
                        />
                    </Grid>
                </Grid>
            </Card>

            <Box className={classes.addEquipSection}>
                <Typography className={classes.addEquipTitle}>
                    {currentLanguage.bepiService.shared.shared_menu_add_equipment}
                </Typography>
                <QuotePageEquipmentSearch
                    searchTerm={buscaEquipamento}
                    onSearchChange={onSearchChange}
                    onSearchFocus={onSearchFocus}
                    suggestions={sugestoesEquipamento}
                    onSelectEquipment={onSelectEquipment}
                    classes={classes}
                    currentLanguage={currentLanguage}
                />
            </Box>

            <Divider style={{ margin: '14px 0' }} />

            {/* 3. Lista de Equipamentos */}
            <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 16 }}>
                {currentLanguage.bepiService.workshop.workshop_quote_form_items_title}
            </Typography>

            <QuotePageEquipmentList
                equipment={equipamentosOrcamento}
                onAddItem={onAddItem}
                onRemoveEquipment={onRemoveEquipment}
                onRemoveItem={onRemoveItem}
                userRole={userRole}
                classes={classes}
                currentLanguage={currentLanguage}
            />

            {/* 4. Resumo Financeiro (apenas admin) */}
            <QuotePageFinancialSummary
                totalItems={totalItens}
                discount={desconto}
                totalFinal={totalFinal}
                onDiscountChange={onDescontoChange}
                userRole={userRole}
                classes={classes}
                currentLanguage={currentLanguage}
            />

            {/* 5. Seção de Anexos (apenas admin) */}
            <QuotePageAttachmentsSection
                activeTab={tabAnexosAtiva}
                attachments={anexos}
                invoices={notasFiscais}
                onTabChange={onTabAnexosChange}
                onUploadAttachment={onUploadAnexo}
                onUploadInvoice={onUploadNota}
                onDeleteAttachment={onExcluirAnexo}
                onDeleteInvoice={onExcluirNota}
                userRole={userRole}
                classes={classes}
                currentLanguage={currentLanguage}
            />

            {/* 6. Botão de Salvar */}
            <Box className={classes.buttonContainer}>
                <CustomButton
                    variant="greenFilled"
                    onClick={onSaveQuote}
                >
                    {currentLanguage.bepiService.workshop.workshop_quote_form_save_btn}
                </CustomButton>
            </Box>

            {/* 7. Modal de Itens */}
            <QuotePageModalItens
                open={modalItensAberto}
                onClose={onFecharModalItens}
                searchTerm={buscaItemModal}
                onSearchChange={onBuscaItemModalChange}
                filteredItems={itensFiltrados}
                onSelectItem={onAbrirOverlay}
                formatCurrency={formatCurrency}
                classes={classes}
                currentLanguage={currentLanguage}
            />

            {/* 8. Overlay de Adicionar Item */}
            <QuotePageOverlayAdd
                open={overlayAberto}
                item={overlayItem}
                quantity={overlayQtd}
                observation={overlayObs}
                priceOption={overlayPreco}
                userRole={userRole}
                onQuantityChange={onOverlayQtdChange}
                onObservationChange={onOverlayObsChange}
                onPriceOptionChange={onOverlayPrecoChange}
                onCancel={onFecharOverlay}
                onConfirm={onConfirmarOverlay}
                formatCurrency={formatCurrency}
                classes={classes}
                currentLanguage={currentLanguage}
            />
        </Box>
    );
};

export default withStyles(styles)(QuotePageForm);
